"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const React = __importStar(require("react"));
const react_copy_to_clipboard_1 = __importDefault(require("react-copy-to-clipboard"));
const OperationalContext_1 = __importDefault(require("../OperationalContext/OperationalContext"));
const utils_1 = require("../utils");
const styled_1 = __importDefault(require("../utils/styled"));
const Input_constants_1 = require("./Input.constants");
const Icon_1 = require("../Icon");
const Button = styled_1.default("button") `
  width: ${Input_constants_1.height}px;
  /** Makes sure the button doesn't shrink when inside a flex container */
  flex: 0 0 ${Input_constants_1.height}px;
  height: ${Input_constants_1.height}px;
  top: 0px;
  left: 0px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  outline: none;
  /* Don't respond to children's pointer-events */
  * {
    pointer-events: none;
  }
  ${({ theme }) => `
    background-color: ${theme.color.background.lighter};
    border-top-left-radius: ${theme.borderRadius}px;
    border-bottom-left-radius: ${theme.borderRadius}px;
    box-shadow: 0 0 0 1px ${theme.color.border.default};
    border:none;
    color: ${theme.color.text.light};
    :focus {
     ${utils_1.inputFocus({ theme })},
    }
    :hover {
      background-color: ${theme.color.background.light};
    }
  `};
`;
const InputButton = ({ tabIndex, icon: Icon, copy, value, onIconClick }) => {
    if (!Icon && !copy) {
        return null;
    }
    return copy === true ? (React.createElement(OperationalContext_1.default, null, ({ pushMessage }) => (React.createElement(react_copy_to_clipboard_1.default, { text: value || "", onCopy: () => pushMessage({ body: "Copied to clipboard", type: "info" }) },
        React.createElement(Button, { tabIndex: tabIndex },
            React.createElement(Icon_1.CopyIcon, { size: 16 })))))) : (React.createElement(Button, { onClick: onIconClick }, typeof Icon === "function" ? React.createElement(Icon, { size: 16 }) : Icon));
};
exports.default = InputButton;
//# sourceMappingURL=Input.Button.js.map